export const rubrosHistoricos = [

    {
        "anio": "2025",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../historico/PrimerTrimestre2025.rar"
            },

            {
                "trimestre": "Segundo Trimestre",
                "url": "../historico/SegundoTrimestre2025.rar"
            },

            {
                "trimestre": "Tercer Trimestre",
                "url": "../historico/TercerTrimestre2025.rar"
            },

            {
                "trimestre": "Cuarto Trimestre",
                "url": "../historico/CuartoTrimestre2025.rar"
            }
            
            
            
        ]
    },

    {
        "anio": "2024",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../historico/PrimerTrimestre2024.rar"
            },
            {
                "trimestre": "Segundo Trimestre",
                "url": "../historico/SegundoTrimestre2024.rar"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../historico/TercerTrimestre2024.rar"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../historico/CuartoTrimestre2024.rar"
            }
            
        ]
    },

    {
        "anio": "2023",
        "descripcion": "Disponibilidad de los trimestres anteriores",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../historico/PrimerTrimestre2023.rar"
            },
            {
                "trimestre": "Segundo Trimestre",
                "url": "../historico/SegundoTrimestre2023.rar"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../historico/TercerTrimestre2023.rar"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../historico/CuartoTrimestre2023.rar"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url": "../historico/PrimerTrimestre2022.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url": "../historico/SegundoTrimestre2022.rar"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../historico/TercerTrimestre2022.rar"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../historico/CuartoTrimestre2022.rar"
            }
        ]
    },{
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url": "../historico/PrimerTrimestre2021.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url": "../historico/SegundoTrimestre2021.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url": "../historico/TercerTrimestre2021.rar"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url": "../historico/CuartoTrimestre2021.rar"
            }
        ]
    },{
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url": "../historico/PrimerTrimestre2020.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url": "../historico/SegundoTrimestre2020.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url": "../historico/TercerTrimestre2020.rar"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url": "../historico/CuartoTrimestre2020.rar"
            }
        ]
    },{
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url": "../historico/PrimerTrimestre2019.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url": "../historico/SegundoTrimestre2019.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url": "../historico/TercerTrimestre2019.rar"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url": "../historico/CuartoTrimestre2019.rar"
            }
        ]
    },{
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url": "../historico/PrimerTrimestre2018.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url": "../historico/SegundoTrimestre2018.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url": "../historico/TercerTrimestre2018.rar"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url": "../historico/CuartoTrimestre2018.rar"
            }
        ]
    },{
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url": "../historico/2015-2017.rar"
            }
        ]
    },{
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url": "../historico/21rubros.rar"
            }
        ]
    }
]